var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"scroll-to-top-btn",attrs:{"fab":"","small":"","fixed":"","bottom":"","right":"","color":"primary","aria-label":"Volver al inicio"},on:{"click":_vm.scrollToTop}},[_c('v-icon',[_vm._v("mdi-chevron-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }